<script>
import {
  CdrSkeleton,
  CdrSkeletonBone,
} from '@rei/cedar';

export default {
  name: 'CardLoader',
  components: {
    CdrSkeleton,
    CdrSkeletonBone,
  },
};
</script>
<template>
  <cdr-skeleton>
    <cdr-skeleton-bone type="rectangle" />
    <div class="skeleton-card--body">
      <cdr-skeleton-bone type="line" />
      <cdr-skeleton-bone type="line" />
      <cdr-skeleton-bone type="line" />
    </div>
  </cdr-skeleton>
</template>
